// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__7DTbc","button":"Checkbox_button__1LgWS"};